import { Typography, MediaImageStandard, Link } from 'components/Contentful'

export const Card = ({ content }) => {
  if (content === undefined || Object.keys(content).length === 0) return null
  const { cardTitleText, cardText, cardLink, cardImage } = content?.fields || {}

  return (
    <div className="m-4 p-6 text-left text-inherit no-underline border border-[#eaeaea] rounded-[10px] transition-colors duration-150 ease-in-out max-w-[300px] hover:text-[#0070f3] hover:border-[#0070f3] focus:text-[#0070f3] focus:border-[#0070f3] active:text-[#0070f3] active:border-[#0070f3]">
      {cardImage && <MediaImageStandard content={cardImage} />}
      <div className="my-4" />
      <div className="flex flex-col gap-2">
        <div>
          {cardTitleText && (
            <div className="mb-4 text-2xl font-semibold">
              <Typography content={cardTitleText} />
            </div>
          )}
          {cardText && (
            <div className="text-xl leading-[1.5]">
              <Typography content={cardText} />
            </div>
          )}
        </div>
        {cardLink && <Link content={cardLink} />}
      </div>
    </div>
  )
}
